import React from 'react';
import { Button } from '../ui/Button';
import { PlusIcon } from '@heroicons/react/24/outline';

const FormActions = ({ onCancel, isLoading, language }) => {
  return (
    <div className="flex items-center justify-end space-x-4 pt-6 border-t border-gray-200 dark:border-gray-700">
      <Button 
        type="button" 
        variant="outline" 
        onClick={onCancel}
        disabled={isLoading}
      >
        {language === 'tr' ? 'İptal' : 'Cancel'}
      </Button>
      
      <Button 
        type="submit" 
        disabled={isLoading}
        className="min-w-[120px]"
      >
        {isLoading ? (
          <div className="flex items-center space-x-2">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
            <span>{language === 'tr' ? 'Oluşturuluyor...' : 'Creating...'}</span>
          </div>
        ) : (
          <div className="flex items-center space-x-2">
            <PlusIcon className="w-4 h-4" />
            <span>{language === 'tr' ? 'Proje Oluştur' : 'Create Project'}</span>
          </div>
        )}
      </Button>
    </div>
  );
};

export default FormActions;